{
  "nav": {
    "stats": "Statistik",
    "registerCatch": "Fang registrieren",
    "myCatches": "Meine Fänge",
    "myFiskekort": "Meine Angellizenzen",
    "myBookings": "Meine Buchungen",
    "profile": "Profil",
    "login": "Anmelden",
    "logout": "Abmelden",
    "admin": "Admin",
    "valdAdmin": "Vald-Verwaltung",
    "riverAdmin": "Fluss-Verwaltung",
    "history": "Verlauf",
    "buyFiskekort": "Angelkarte kaufen",
    "registerLink": "Konto erstellen",
    "loggFiskedag": "Angeltag buchen",
    "contact": "Kontakt",
    "language": "Sprache",
    "fiskeHer": "Hier angeln",
    "sectionFishing": "Angeln",
    "sectionExplore": "Entdecken",
    "sectionAccount": "Mein Konto",
    "sectionManagement": "Verwaltung",
    "sectionForOwners": "Für Eigentümer",
    "sellFiskekort": "Angelkarten verkaufen",
    "riverOwnersAssoc": "Flussbesitzerverband",
    "photoContest": "Fotowettbewerb",
    "adminPhotoContest": "Fotowettbewerb (Admin)",
    "menu": "Menü",
    "openMenu": "Menü öffnen",
    "closeMenu": "Menü schließen",
    "privacy": "Datenschutz",
    "rivers": "Flüsse & Reviere"
  },
  "stats": {
    "title": "Fangstatistik",
    "filterYear": "Jahr",
    "filterMonth": "Monat",
    "filterWeek": "Woche",
    "filterDay": "Tag",
    "totalCatches": "Gesamtfänge",
    "totalWeight": "Gesamtgewicht",
    "avgWeight": "Durchschnittsgewicht",
    "biggestFish": "Größter Fisch",
    "released": "Zurückgesetzt",
    "recentCatches": "Letzte Fänge",
    "noData": "Keine Fänge im ausgewählten Zeitraum",
    "allRivers": "Alle Flüsse",
    "allValds": "Alle Vald",
    "viewVald": "Valdseite anzeigen →",
    "uniqueAnglers": "Angler",
    "cpue": "Fänge pro Angler",
    "registerCatchDesc": "Erfasse den Fisch, den du gefangen hast, mit Art, Gewicht und Länge. Dein Name wird standardmäßig nicht öffentlich angezeigt.",
    "startFishingDesc": "Tippe, wenn du mit dem Angeln beginnst, und auf „Angeln beendet“, wenn du fertig bist. Wir speichern nur Zeiten, nie deinen Standort.",
    "intro": "Lakseborsen ist eine offene <b>Lachsbörse</b>, die <b>Lachsstatistiken</b> aus registrierten norwegischen Lachs- und Meerforellenflüssen in Echtzeit sammelt. Sieh dir die aktuellen Fangzahlen für <b>{{year}}</b> an — Anzahl der Fänge, Gesamtgewicht, Durchschnittsgewicht und größter Fisch pro Fluss oder Strecke. Unter <history>Fanghistorie</history> findest du Saisons bis zurück ins Jahr 2014."
  },
  "catch": {
    "title": "Fang registrieren",
    "vald": "Vald (Angelzone)",
    "selectVald": "Vald auswählen…",
    "fishType": "Fischart",
    "weight": "Gewicht (kg)",
    "weightKg": "Gewicht (kg)",
    "length": "Länge (cm)",
    "lengthCm": "Länge (cm)",
    "date": "Datum",
    "time": "Uhrzeit",
    "gear": "Ausrüstung",
    "photo": "Foto (optional)",
    "photoUploadFailed": "Foto-Upload fehlgeschlagen",
    "released": "Zurückgesetzt",
    "fromBoat": "Vom Boot",
    "sex": "Geschlecht (optional)",
    "sexTypes": {
      "hann": "Männlich",
      "hunn": "Weiblich"
    },
    "seaLice": "Lachslaus",
    "fisher": "Angler",
    "roer": "Ruderer",
    "onBehalf": {
      "question": "Für wen ist dieser Fang?",
      "self": "Für mich selbst",
      "other": "Für einen anderen Angler",
      "fisherName": "Name des Anglers",
      "fisherNamePlaceholder": "Name eingeben",
      "recent": "Zuletzt verwendet"
    },
    "conditions": "Bedingungen zum Fangzeitpunkt",
    "airTemp": "Lufttemperatur",
    "precipitation": "Niederschlag",
    "windSpeed": "Windstärke",
    "waterTemp": "Wassertemperatur",
    "waterFlow": "Wasserstand",
    "nveStationSource": "Quelle: {{station}}",
    "weatherPending": "Wetterdaten verfügbar in ca. 5 Tagen",
    "submit": "Registrieren",
    "submitting": "Speichern…",
    "success": "Fang registriert!",
    "offlineDraft": "Lokal gespeichert — wird automatisch gesendet, wenn Sie online sind",
    "fishTypes": {
      "laks": "Atlantischer Lachs",
      "brunørret": "Bachforelle",
      "sjøørret": "Meerforelle",
      "pukkellaks": "Buckellachs",
      "oppdrettslaks": "Zuchtlachs",
      "støing": "Blanklachs",
      "røye": "Saibling",
      "ørret": "Meerforelle"
    },
    "gearTypes": {
      "flue": "Fliegenfischen",
      "wobbler": "Wobbler",
      "spinner": "Spinner",
      "sluk": "Löffel",
      "mark_orm": "Wurm / Köder",
      "rapala": "Rapala",
      "annet": "Sonstiges"
    },
    "errors": {
      "valdRequired": "Bitte eine Angelzone wählen",
      "weightInvalid": "Gewicht muss zwischen 0.1 und 100 kg liegen",
      "lengthInvalid": "Länge muss zwischen 5 und 250 cm liegen",
      "dateRequired": "Bitte Datum und Uhrzeit angeben",
      "fisherNameRequired": "Bitte den Namen des Anglers eingeben"
    },
    "fishingDayPrompt": "Heute gefischt ohne Fang?",
    "logFishingDay": "Angeltag eintragen",
    "logFishingDayDone": "Angeltag eingetragen ✓",
    "edit": "Bearbeiten",
    "editTitle": "Fang bearbeiten",
    "editSave": "Änderungen speichern",
    "editSaved": "Fang aktualisiert!",
    "locate": {
      "button": "Meinen Standort verwenden",
      "locating": "Standort wird ermittelt…",
      "found": "Nächstes Vald gefunden: {{vald}}",
      "unsupported": "Standort wird von diesem Browser nicht unterstützt",
      "denied": "Du musst den Standortzugriff erlauben, um dies zu nutzen",
      "failed": "Standort konnte nicht ermittelt werden",
      "noneFound": "Keine Valds in der Nähe haben Standortdaten"
    },
    "photoPendingOffline": "Das Foto wird automatisch hochgeladen, sobald du wieder online bist",
    "photoChange": "Foto ändern",
    "photoAdd": "Foto hinzufügen",
    "photoPreviewAlt": "Vorschau",
    "fishingDayOffline": "Lokal gespeichert — wird automatisch protokolliert, sobald du online bist",
    "showNamePublic": "Meinen Namen öffentlich anzeigen",
    "showNamePublicDesc": "Standardmäßig aus. Der Fang zählt in jedem Fall in der Statistik."
  },
  "bulk": {
    "title": "Kleinfische erfassen (Bulk)",
    "intro": "Viele kleine Forellen gefangen? Erfassen Sie alle auf einmal statt einzeln.",
    "count": "Anzahl Fische",
    "countHint": "{{count}} Fische werden registriert",
    "allReleased": "Alle zurückgesetzt",
    "optionalMeasurements": "Optionale Maße (leer lassen wenn unbekannt)",
    "avgWeight": "Durchschnittsgewicht (kg)",
    "avgLength": "Durchschnittslänge (cm)",
    "lengthHint": "Meist unter 40 cm",
    "submit": "{{count}} Fische registrieren",
    "submitting": "Wird registriert…",
    "success": "{{count}} Fische registriert!",
    "successDetail": "Die Fänge wurden gespeichert und erscheinen in der Statistik.",
    "registerMore": "Mehr registrieren",
    "backToForm": "Normale Registrierung",
    "bulkLink": "Viele kleine Forellen gefangen? → Bulk-Registrierung",
    "errors": {
      "countInvalid": "Anzahl muss zwischen 1 und 50 liegen"
    },
    "decreaseCount": "Verringern",
    "increaseCount": "Erhöhen"
  },
  "myCatches": {
    "title": "Meine Fänge",
    "empty": "Sie haben noch keine Fänge registriert.",
    "registerFirst": "Ersten Fang registrieren",
    "exportCsv": "Meine Fänge herunterladen",
    "exportError": "Fänge konnten nicht heruntergeladen werden"
  },
  "profile": {
    "title": "Mein Profil",
    "displayName": "Name",
    "language": "Sprache",
    "save": "Speichern",
    "saved": "Gespeichert!",
    "security": "Sicherheit",
    "passkey": "Passkey (biometrische Anmeldung)",
    "passkeyDesc": "Melden Sie sich schnell mit Fingerabdruck, Gesichtserkennung oder einem Sicherheitsschlüssel an.",
    "registerPasskey": "Passkey registrieren",
    "addPasskey": "Weiteren Passkey hinzufügen",
    "passkeyDefaultLabel": "Passkey",
    "passkeyAdded": "Hinzugefügt {{date}}",
    "deletePasskey": "Löschen",
    "confirmDeletePasskey": "Passkey \"{{label}}\" löschen?",
    "hideNamePublic": "Fänge anonym zeigen",
    "hideNamePublicDesc": "Dein Name wird in öffentlichen Statistiken nicht angezeigt. Deine Fänge werden trotzdem gezählt.",
    "deleteAccount": "Konto löschen",
    "deleteAccountDesc": "Entfernt deinen Namen, deine E-Mail und andere persönliche Angaben aus deinem Profil. Deine Fänge bleiben anonymisiert erhalten, wie es das Gesetz für die Fangmeldung vorschreibt.",
    "confirmDeleteAccount": "Möchtest du dein Konto wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
    "privacy": "Datenschutz",
    "privacyDesc": "Lade alle Daten herunter, die wir über dich gespeichert haben. Siehe auch die Datenschutzerklärung (auf Norwegisch).",
    "exportData": "Meine Daten herunterladen"
  },
  "admin": {
    "title": "Admin-Dashboard",
    "totalCatches": "Gesamtfänge",
    "catchesThisYear": "Fänge dieses Jahr",
    "totalFishers": "Aktive Angler",
    "totalUsers": "Registrierte Nutzer",
    "tabCatches": "Fänge",
    "tabUsers": "Nutzer",
    "dateFrom": "Von Datum",
    "dateTo": "Bis Datum",
    "allFishTypes": "Alle Fischarten",
    "allReleased": "Alle (zurückgesetzt)",
    "keptOnly": "Nur behalten",
    "releasedOnly": "Nur zurückgesetzt",
    "applyFilters": "Filtern",
    "resetFilters": "Zurücksetzen",
    "catchCount": "{{count}} Fänge",
    "exportCsv": "CSV herunterladen",
    "deleteSelected": "Ausgewählte löschen ({{count}})",
    "confirmBulkDeleteCatches": "{{count}} Fang/Fänge löschen? Das kann nicht rückgängig gemacht werden.",
    "bulkDeleteDone": "{{count}} Fang/Fänge gelöscht.",
    "selectAllOnPage": "Alle auf dieser Seite auswählen",
    "selectRow": "Zeile auswählen",
    "fisher": "Angler",
    "yes": "Ja",
    "no": "Nein",
    "prevPage": "Zurück",
    "nextPage": "Weiter",
    "userName": "Name",
    "userEmail": "E-Mail",
    "userRole": "Rolle",
    "userCatches": "Fänge",
    "registered": "Registriert",
    "role_fisher": "Angler",
    "role_admin": "Admin",
    "promote": "Zum Admin machen",
    "demote": "Admin entfernen",
    "tabValds": "Angelzonen",
    "valdName": "Angelzone",
    "valdRiver": "Fluss",
    "valdOwner": "Eigentümer",
    "valdNoOwner": "Kein Eigentümer",
    "assignOwner": "Eigentümer zuweisen",
    "clearOwner": "Eigentümer entfernen",
    "searchVald": "Zone suchen…",
    "searchUser": "Benutzer suchen (Name oder E-Mail)…",
    "search": "Suchen",
    "select": "Auswählen",
    "filterRiver": "Nach Fluss filtern",
    "allRivers": "Alle Flüsse",
    "searchUsers": "Nach Name oder E-Mail suchen…",
    "ownedValds": "Gewässerabschnitte",
    "selectVald": "Gewässerabschnitt wählen…",
    "assignVald": "Abschnitt zuweisen",
    "removeValdOwner": "Eigentümerschaft entfernen",
    "role_river_admin": "Fluss-Admin",
    "promoteRiverAdmin": "Zum Fluss-Admin machen",
    "demoteRiverAdmin": "Fluss-Admin entfernen",
    "selectRiver": "Fluss wählen…",
    "selectRiverSystem": "Flusssystem wählen…",
    "makeRiverAdmin": "Zum Fluss-Admin machen",
    "inviteOwner": "Revierinhaber einladen",
    "inviteHint": "Geben Sie die E-Mail-Adresse des zukünftigen Revierinhabers ein.",
    "inviteEmailPlaceholder": "E-Mail des Inhabers",
    "sendInvite": "Einladung senden",
    "inviteSentOk": "Einladung gesendet an {{email}}",
    "inviteAssignedDirect": "{{email}} ist bereits Nutzer und wurde als Inhaber eingestellt",
    "pendingInvite": "Wartet auf {{email}}",
    "edit": "Bearbeiten",
    "riverClosed": "Vorübergehend geschlossen",
    "riverDescription": "Beschreibung",
    "riverFishingRules": "Angelregeln",
    "riverFlags": "Status",
    "riverMain": "Hauptfluss",
    "riverMunicipalities": "Gemeinde",
    "riverName": "Name",
    "riverNveId": "NVE-Stations-ID",
    "riverNveName": "NVE-Stationsname",
    "riverRequiresDisinfection": "Desinfektion erforderlich",
    "riverSeason": "Saison",
    "riverSeasonClose": "Saisonende (MM-DD)",
    "riverSeasonOpen": "Saisonbeginn (MM-DD)",
    "riverSystem": "System",
    "searchRiver": "Fluss suchen (Name, Gemeinde, System)…",
    "tabRivers": "Flüsse"
  },
  "riverAdmin": {
    "title": "Fluss-Administration",
    "totalCatches": "Gesamtfänge",
    "catchesThisYear": "Fänge in diesem Jahr",
    "allYears": "Alle Jahre",
    "exportCsv": "Excel herunterladen",
    "exportError": "Excel-Download fehlgeschlagen",
    "tabs": {
      "fangster": "Fänge",
      "valds": "Reviere",
      "elver": "Flüsse",
      "meldinger": "Nachrichten",
      "vilkar": "Bedingungen",
      "rettelser": "Korrekturen",
      "fisketrykk": "Angeldruck",
      "elvekort": "Elvekort"
    },
    "rivers": {
      "title": "Saison & Sperrungen",
      "hint": "Saisondaten pro Fluss festlegen. Temporäre Sperrungen werden für Fischer angezeigt.",
      "seasonOpen": "Saison öffnet",
      "seasonClose": "Saison schließt",
      "month": "Monat",
      "day": "Tag",
      "temporarilyClosed": "Vorübergehend gesperrt",
      "temporarilyClosedHint": "Zeigt eine 'Vorübergehend gesperrt'-Warnung auf der öffentlichen Flussseite an. Angler können weiterhin Fänge registrieren und Angelkarten kaufen.",
      "requiresDisinfection": "Desinfektion erforderlich",
      "requiresDisinfectionHint": "Angler müssen beim Kauf einer Lizenz die Desinfektionsmethode bestätigen",
      "save": "Speichern",
      "saved": "Gespeichert ✓",
      "fishingRules": "Fischereiregeln (Text, öffentlich)",
      "fishingRulesPlaceholder": "Regeln, Einschränkungen und andere Infos für Fischer eingeben…",
      "description": "Beschreibung (öffentlich sichtbar)",
      "descriptionPlaceholder": "Schreib eine kurze Beschreibung des Flusses…",
      "images": "Bilder (auf der Flussseite angezeigt)",
      "addPhoto": "+ Foto hinzufügen",
      "municipalities": "Gemeinde",
      "municipalitiesHint": "Wird in SEO-Metadaten und auf der Flussseite angezeigt. Nur vom Site-Administrator änderbar.",
      "municipalitiesPlaceholder": "z. B. Røyrvik, Namsskogan, Grong, Overhalla, Namsos",
      "stayGuide": "So übernachtest du hier (Text, öffentlich sichtbar)",
      "stayGuidePlaceholder": "Tipps, wie Angler am besten übernachten: nächster Ort, was man früh buchen sollte, Restaurants, Ausrüstungsverleih…",
      "nearbyPlaces": "Hotels und Restaurants in der Nähe",
      "placeName": "Name",
      "placeDistance": "Entfernung, z. B. „5 Min. von Formofoss“",
      "placeDescription": "Kurzbeschreibung",
      "addPlace": "+ Ort hinzufügen",
      "seasonEvents": "Was ist in der Saison los (Veranstaltungen)",
      "eventTitle": "Titel, z. B. „Tag des Lachses“",
      "eventStart": "Startdatum",
      "eventEnd": "Enddatum (optional)",
      "eventDescription": "Kurzbeschreibung",
      "addEvent": "+ Veranstaltung hinzufügen",
      "placeLat": "Breitengrad (optional)",
      "placeLon": "Längengrad (optional)",
      "placeHighlight": "Text vom Sponsor (als gesponserter Inhalt angezeigt)",
      "placeTags": "Angebote",
      "placeSponsor": "Unterstützt den Fluss (Sponsor)",
      "placePick": "Empfohlen? Begründung (wird als „Empfohlen vom Flussverband“ angezeigt)",
      "placeLogo": "Logo (optional)",
      "sponsorReport": "Sponsorenbericht",
      "sponsorReportMonth": "Monat",
      "sponsorReportLinks": "Link-Klicks",
      "sponsorReportMap": "Auf Karte zeigen",
      "sponsorReportCopy": "Text kopieren",
      "sponsorReportCopied": "Kopiert",
      "sponsorReportHint": "Zählt Klicks auf den Sponsorlink und „Auf Karte zeigen“. Es werden keine personenbezogenen Daten gespeichert.",
      "sponsorReportText": "{{name}}: Im {{month}} wurde Ihr Link {{link}}-mal angeklickt und „Auf Karte zeigen“ {{map}}-mal genutzt.",
      "sub": {
        "season": "Saison",
        "content": "Inhalt",
        "nearby": "In der Nähe",
        "sponsors": "Sponsoren"
      },
      "selectRiver": "Fluss wählen",
      "systemPlacesNote": "Gilt für alle Flüsse in {{system}}. Einmal hinzufügen, dann erscheint der Ort bei allen Flüssen.",
      "sponsorReportEmpty": "Noch keine Sponsoren. Unter „In der Nähe“ kannst du bei einem Eintrag „Unterstützt den Fluss (Sponsor)“ ankreuzen. Sponsoren erscheinen dann hier mit Klicks pro Monat.",
      "placeFamily": "Für die ganze Familie (auch Nicht-Angler)",
      "placePhone": "Telefon",
      "placeImage": "Bild (Sponsor)",
      "sponsorTier_none": "Kein Sponsor",
      "sponsorTier_friend": "Freund des Flusses",
      "sponsorTier_local": "Lokale Unterstützung",
      "sponsorTier_supporter": "Unterstützer",
      "sponsorTier_partner": "Partner",
      "sponsorTier_main": "Hauptsponsor"
    },
    "valds": {
      "title": "Reviere",
      "ownerLabel": "Eigentümer",
      "noOwner": "Kein Eigentümer",
      "assignOwner": "Eigentümer ändern",
      "clearOwner": "Eigentümer entfernen",
      "searchUsers": "Benutzer suchen (Name oder E-Mail)…"
    },
    "messaging": {
      "title": "Nachricht senden",
      "recipients": "Empfänger",
      "recipientValdeiere": "Revierinhaber",
      "recipientFishers": "Angler",
      "recipientAll": "Alle",
      "subject": "Betreff",
      "body": "Nachricht",
      "send": "Nachricht senden",
      "sending": "Senden…",
      "sent": "An {{count}} Empfänger gesendet",
      "sentCount": "Gesendet",
      "history": "Gesendete Nachrichten",
      "empty": "Noch keine Nachrichten gesendet",
      "recipientCustom": "Einzelpersonen",
      "emailToggle": "Auch per E-Mail senden ({{count}} mit E-Mail)",
      "previewCount": "{{count}} Empfänger",
      "noRecipients": "Keine Empfänger gefunden",
      "sendBtn": "An {{count}} Empfänger senden"
    }
  },
  "notifications": {
    "title": "Benachrichtigungen",
    "markAllRead": "Alle als gelesen markieren",
    "empty": "Keine Benachrichtigungen",
    "typeMessageReceived": "Neue Nachricht",
    "typeValdOwnerAssigned": "Revier zugewiesen"
  },
  "common": {
    "loading": "Laden…",
    "noResults": "Keine Ergebnisse",
    "error": "Etwas ist schiefgelaufen",
    "retry": "Erneut versuchen",
    "kg": "kg",
    "cm": "cm",
    "back": "Zurück",
    "clear": "Löschen",
    "delete": "Löschen",
    "paymentMethods": "Wir akzeptieren Vipps, Karte (Visa/Mastercard) und MobilePay.",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "previousMonth": "Vorheriger Monat",
    "nextMonth": "Nächster Monat"
  },
  "auth": {
    "loginRequired": "Anmelden um fortzufahren",
    "loginForCatch": "Anmelden um Fang zu registrieren",
    "loginForMyCatches": "Anmelden um Ihre Fänge zu sehen",
    "loginForProfile": "Anmelden um Ihr Profil zu sehen",
    "loginHint": "Sie können sich mit Google, E-Mail-Link oder Passwort anmelden",
    "registerHint": "Neuer Benutzer?",
    "registerLink": "Konto erstellen"
  },
  "history": {
    "title": "Fangverlauf",
    "year": "Jahr",
    "week": "Woche",
    "weekLabel": "Woche {{week}}",
    "allWeeks": "Alle Wochen",
    "colTime": "Zeit",
    "colFish": "Fischart",
    "colWeight": "Gewicht",
    "colLength": "Länge",
    "colGear": "Ausrüstung",
    "colVald": "Vald",
    "colFisher": "Angler",
    "colReleased": "Zurückgesetzt"
  },
  "valdPage": {
    "river": "Fluss",
    "owner": "Eigentümer",
    "noOwner": "Nicht verfügbar",
    "catchesThisYear": "Fangänge dieses Jahr",
    "fiskekortTitle": "Angelkarte",
    "noFiskekort": "Keine Angelkarten für diesen Abschnitt verfügbar",
    "loginToBook": "Einloggen um eine Angelkarte zu kaufen",
    "buy": "Kaufen",
    "price": "Preis",
    "durationDay": "{{count}} Tag",
    "durationDays": "{{count}} Tage",
    "seasonLabel": "Saison",
    "unlimited": "Unbegrenzt",
    "available": "Verfügbar",
    "remaining": "{{count}} verfügbar",
    "soldOut": "Ausverkauft",
    "seasonOpens": "Saison öffnet {{date}}",
    "seasonEnded": "Saison ist beendet",
    "preBook": "Vorbuchen",
    "packagesTitle": "Pakete",
    "noPackages": "Keine Pakete verfügbar",
    "packageIncludes": "Beinhaltet",
    "combinedPrice": "Gesamtpreis: {{price}} kr",
    "orderPackageBtn": "Paket bestellen",
    "accommodationTitle": "Unterkunft",
    "accommodationNoCardRequired": "Angelkarte nicht erforderlich – jeder kann eine Unterkunft buchen.",
    "noAccommodation": "Keine Unterkunft verfügbar",
    "capacity": "{{count}} Person",
    "capacity_plural": "{{count}} Personen",
    "perNight": "/ Nacht",
    "book": "Unterkunft buchen",
    "accommodationType_hytte": "Hütte",
    "accommodationType_rom": "Zimmer",
    "accommodationType_telt": "Zeltplatz",
    "accommodationType_campingvogn": "Wohnwagen",
    "accommodationType_annet": "Sonstiges",
    "omOssTitle": "Über uns",
    "contactPhone": "Telefon",
    "contactEmail": "E-Mail",
    "contactWebsite": "Webseite",
    "tilgjengelighet": "Erreichbarkeit",
    "avstandBilvei": "Entfernung zur Straße",
    "editVald": "Revier bearbeiten",
    "fishingSpotsTitle": "Angelstellen",
    "seePermits": "Angelkarten ansehen"
  },
  "fiskekort": {
    "purchaseTitle": "Angelkarte kaufen",
    "product": "Produkt",
    "vald": "Abschnitt",
    "validFrom": "Erster Tag",
    "validTo": "Gültig bis",
    "price": "Preis",
    "confirm": "Kauf bestätigen",
    "submitting": "Kaufe…",
    "success": "Angelkarte gekauft!",
    "successDescription": "Ihre Karte ist jetzt aktiv.",
    "viewMyCards": "Meine Angelkarten anzeigen",
    "currency": "NOK",
    "paymentProcessing": "Zahlung wird verarbeitet…",
    "paymentCancelled": "Zahlung abgebrochen",
    "paymentCancelledDesc": "Sie können den Angelschein erneut kaufen.",
    "paymentPending": "Zahlung eingegangen",
    "paymentPendingDesc": "Wir warten auf die Bestätigung des Zahlungsanbieters. Ihr Schein erscheint unter Meine Angelscheine nach der Bestätigung.",
    "seasonNote": "Saison: {{open}} – {{close}}",
    "errorBeforeSeason": "Das gewählte Datum liegt außerhalb der Saison. Die Saison beginnt am {{open}}.",
    "errorAfterSeason": "Der Angelschein überschreitet das Saisonende ({{close}}). Bitte wählen Sie ein früheres Startdatum.",
    "disinfectionTitle": "Desinfektion (erforderlich)",
    "disinfectionHint": "Dieser Fluss verlangt, dass Sie bestätigen, dass Ihre Ausrüstung und/oder Ihr Boot desinfiziert wurde.",
    "disinfectionRequired": "Sie müssen eine Desinfektionsmethode auswählen.",
    "disinfectionMethod": {
      "dried_2weeks": "Getrocknet (mind. 2 Wochen)",
      "frozen": "Eingefroren",
      "heat_treated": "Wärmebehandelt (mind. 60 °C)",
      "chemical": "Chemisch desinfiziert"
    },
    "quantity": "Anzahl Angelscheine",
    "totalPrice": "Gesamtpreis"
  },
  "myFiskekort": {
    "title": "Meine Angelkarten",
    "empty": "Noch keine Angelkarten vorhanden.",
    "validFrom": "Von",
    "validTo": "Bis",
    "status": "Status",
    "status_confirmed": "Aktiv",
    "status_cancelled": "Storniert",
    "status_pending": "Ausstehend",
    "vald": "Abschnitt",
    "product": "Typ",
    "price": "Bezahlt",
    "bookAgain": "Erneut buchen →",
    "showProof": "Nachweis anzeigen",
    "registerCatch": "Fang registrieren"
  },
  "myBookings": {
    "title": "Meine Buchungen",
    "empty": "Noch keine Buchungen vorhanden.",
    "listing": "Unterkunft",
    "checkIn": "Anreise",
    "checkOut": "Abreise",
    "guests": "Gäste",
    "total": "Gesamt",
    "status_confirmed": "Bestätigt",
    "status_cancelled": "Storniert",
    "status_pending": "Ausstehend",
    "cancelBtn": "Buchung stornieren",
    "cancelConfirm": "Möchten Sie diese Buchung wirklich stornieren?",
    "cancelling": "Storniert…",
    "cancelError": "Stornierung nicht möglich. Bitte erneut versuchen.",
    "refundNote": "Buchung storniert. Eine eventuelle Rückerstattung wird innerhalb von 5 Werktagen manuell bearbeitet."
  },
  "valdAdmin": {
    "title": "Abschnittsverwaltung",
    "myValds": "Meine Abschnitte",
    "selectVald": "Abschnitt auswählen",
    "searchVald": "Zone suchen…",
    "catchesThisYear": "Fangänge dieses Jahr",
    "totalCatches": "Fangänge gesamt",
    "fiskekortTitle": "Angelkarten",
    "addProduct": "Angelkarte hinzufügen",
    "editProduct": "Bearbeiten",
    "deactivateProduct": "Deaktivieren",
    "noProducts": "Noch keine Angelkarten konfiguriert",
    "description": "Beschreibung",
    "savedDescription": "Gespeichert!",
    "saveDescription": "Beschreibung speichern",
    "purchasesTitle": "Verkaufte Karten",
    "noPurchases": "Noch keine Verkäufe",
    "productName": "Name",
    "productPrice": "Preis (øre)",
    "productDuration": "Dauer (Tage)",
    "productSeasonStart": "Saisonbeginn (YYYY-MM-DD)",
    "productSeasonEnd": "Saisonende (YYYY-MM-DD)",
    "productQuota": "Kontingent (leer = unbegrenzt)",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "saving": "Speichert…",
    "confirmDeactivate": "Dieses Produkt deaktivieren?",
    "confirmForceDeleteProduct": "Das Produkt hat bestätigte Käufe. Dauerhaft löschen (einschließlich aller Käufe)? Das kann nicht rückgängig gemacht werden.",
    "purchaseFisher": "Angler",
    "purchaseProduct": "Produkt",
    "purchaseValid": "Gültig",
    "purchaseStatus": "Status",
    "purchasePaid": "Bezahlt",
    "backToValds": "Zurück zur Übersicht",
    "viewPublicPage": "Öffentliche Seite ansehen",
    "tabFiskekort": "Angelkarten",
    "tabAccommodation": "Unterkunft",
    "tabPackages": "Pakete",
    "tabSettings": "Einstellungen",
    "tabRevenue": "Einnahmen",
    "addListing": "Unterkunft hinzufügen",
    "editListing": "Bearbeiten",
    "deactivateListing": "Deaktivieren",
    "activateListing": "Aktivieren",
    "managePhotos": "Fotos",
    "addPhoto": "Foto hinzufügen",
    "deletePhoto": "Foto löschen",
    "uploadingPhoto": "Wird hochgeladen...",
    "confirmDeletePhoto": "Dieses Foto löschen?",
    "noListings": "Noch keine Unterkünfte",
    "listingName": "Name",
    "listingType": "Typ",
    "listingCapacity": "Kapazität (Personen)",
    "listingPrice": "Preis pro Nacht (øre)",
    "listingDesc": "Beschreibung",
    "listingProximityNote": "Entfernung zum Angelplatz",
    "listingProximityNotePlaceholder": "z.B. 5 Min. Fahrt von Sektion 2",
    "listingOpenFrom": "Geöffnet ab (MM-TT)",
    "listingOpenTo": "Geöffnet bis (MM-TT)",
    "listingMinNights": "Min. Nächte",
    "listingMaxNights": "Max. Nächte",
    "blockedPeriods": "Gesperrte Zeiträume",
    "noBlockedPeriods": "Keine gesperrten Zeiträume.",
    "addBlockedPeriod": "Sperre hinzufügen",
    "blockedFrom": "Von",
    "blockedTo": "Bis",
    "blockedReason": "Grund (optional)",
    "blockedReasonHint": "z.B. Wartung",
    "bookingsTitle": "Buchungsanfragen für {{name}}",
    "noBookings": "Keine Buchungsanfragen",
    "bookingGuest": "Gast",
    "bookingDates": "Zeitraum",
    "bookingStatus": "Status",
    "bookingConfirm": "Bestätigen",
    "bookingCancel": "Ablehnen",
    "bookingStatus_pending": "Ausstehend",
    "bookingStatus_confirmed": "Bestätigt",
    "bookingStatus_cancelled": "Abgelehnt",
    "addPackage": "Paket hinzufügen",
    "editPackage": "Bearbeiten",
    "deletePackage": "Löschen",
    "noPackages": "Noch keine Pakete",
    "packageName": "Name",
    "packageDesc": "Beschreibung",
    "packageFiskekort": "Angelkarte (optional)",
    "packageAccommodation": "Unterkunft (optional)",
    "packageCombinedPrice": "Gesamtpreis in øre (optional)",
    "packageNone": "— keins —",
    "contactTitle": "Kontakt (Über uns)",
    "contactName": "Name / Organisation",
    "contactPhone": "Telefon",
    "contactEmail": "E-Mail",
    "contactWebsite": "Webseite",
    "saveContact": "Kontaktinfo speichern",
    "fishingOptionsTitle": "Angeloptionen",
    "suitableForFlyFishing": "Geeignet für Fliegenfischen",
    "fishingFromBoat": "Angeln vom Boot möglich",
    "saveFishingOptions": "Angeloptionen speichern",
    "seasonPicker": {
      "yearRound": "Ganzjährig",
      "yearRoundNote": "Das ganze Jahr verfügbar",
      "selectStart": "Startdatum auswählen",
      "selectEnd": "Enddatum auswählen"
    },
    "calendarPreview": "Kalendervorschau anzeigen",
    "calendarPreviewHide": "Kalendervorschau ausblenden",
    "setupChecklist": {
      "title": "Erste Schritte – Vald einrichten",
      "step1": "Vald beschreiben",
      "step2": "Angelschein-Produkt hinzufügen",
      "step3": "Unterkunft hinzufügen",
      "step4": "Paket erstellen",
      "optional": "optional",
      "packageHint": "Erstellen Sie zuerst ein Angelschein-Produkt und ein Unterkunftsangebot, bevor Sie ein Paket anlegen."
    }
  },
  "accommodation": {
    "bookTitle": "Unterkunft buchen",
    "listing": "Unterkunft",
    "checkIn": "Anreise",
    "checkOut": "Abreise",
    "guestCount": "Anzahl Gäste",
    "guestName": "Ihr Name",
    "guestEmail": "E-Mail",
    "guestPhone": "Telefon (optional)",
    "notes": "Nachricht an den Eigentümer (optional)",
    "totalPrice": "Gesamtpreis",
    "totalNights": "{{count}} Nacht",
    "totalNights_plural": "{{count}} Nächte",
    "bookBtn": "Buchungsanfrage senden",
    "submitting": "Wird gesendet…",
    "success": "Anfrage gesendet!",
    "successDetail": "Der Eigentümer wird Sie zur Bestätigung kontaktieren.",
    "loginRequired": "Sie müssen angemeldet sein, um eine Unterkunft zu buchen",
    "perNight": "/ Nacht",
    "datesUnavailable": "Diese Daten sind nicht verfügbar, bitte andere Daten wählen",
    "paymentProcessing": "Zahlung wird bearbeitet…",
    "paymentConfirmed": "Zahlung bestätigt!",
    "paymentConfirmedDesc": "Ihre Buchung ist bestätigt. Wir freuen uns auf Ihren Besuch!",
    "paymentCancelled": "Zahlung abgebrochen",
    "paymentCancelledDesc": "Die Zahlung wurde abgebrochen. Sie können es erneut versuchen.",
    "paymentPending": "Zahlung ausstehend",
    "paymentPendingDesc": "Die Zahlung ist noch nicht bestätigt. Überprüfen Sie Meine Buchungen in Kürze.",
    "viewMyBookings": "Meine Buchungen ansehen",
    "unavailablePeriods": "Belegte Zeiträume",
    "blockedPeriods": "Gesperrte Zeiträume",
    "seasonWindow": "Saison geöffnet {{from}} – {{to}}",
    "minNightsHint": "Mindestens {{count}} Nächte",
    "maxNightsHint": "Höchstens {{count}} Nächte",
    "minNightsError": "Mindestens {{count}} Nächte erforderlich",
    "maxNightsError": "Höchstens {{count}} Nächte möglich",
    "outsideSeason": "Ausgewählte Daten liegen außerhalb der Saison"
  },
  "fiskekortList": {
    "title": "Verfügbare Angelkarten",
    "intro": "Stöbern und Angelkarten kaufen",
    "noProducts": "Derzeit keine Angelkarten verfügbar",
    "buy": "Kaufen",
    "soldOut": "Ausverkauft",
    "unlimited": "Unbegrenzt",
    "remaining": "{{count}} übrig",
    "durationDay": "1 Tag",
    "durationDays": "{{count}} Tage",
    "calendarView": "Kalender",
    "listView": "Liste",
    "noProductsDay": "Keine Angelkarten für diesen Tag verfügbar",
    "legendAvailable": "Verfügbar",
    "legendSoldOut": "Ausverkauft"
  },
  "fishingDay": {
    "title": "Angeltag eintragen",
    "intro": "Registriere, dass du heute geangelt hast, ohne etwas gefangen zu haben.",
    "submit": "Angeltag eintragen",
    "submitting": "Wird gespeichert…",
    "success": "Angeltag registriert!",
    "successCta": "Möchtest du einen Fang registrieren?",
    "calendarTitle": "Deine Angeltage",
    "noCatches": "kein Fang",
    "catchCount_one": "{{count}} Fang",
    "catchCount_other": "{{count}} Fänge",
    "delete": "Entfernen",
    "confirmDelete": "Diesen Angeltag entfernen?"
  },
  "contact": {
    "title": "Kontakt",
    "intro": "Haben Sie Fragen oder Rückmeldungen? Schreiben Sie uns eine Nachricht.",
    "name": "Name",
    "email": "E-Mail-Adresse",
    "message": "Nachricht",
    "send": "Nachricht senden",
    "sending": "Wird gesendet...",
    "successMessage": "Danke! Wir haben Ihre Nachricht erhalten und melden uns bald.",
    "errorMessage": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut."
  },
  "revenue": {
    "title": "Einnahmen",
    "year": "Jahr",
    "fiskekortTotal": "Angelscheine",
    "bookingsTotal": "Unterkunft",
    "grandTotal": "Gesamt",
    "fiskekortSales": "Verkaufte Angelscheine",
    "accommodationBookings": "Unterkunftsbuchungen",
    "noData": "Keine Daten für das gewählte Jahr.",
    "exportCsv": "CSV herunterladen",
    "product": "Produkt",
    "date": "Datum",
    "amount": "Betrag",
    "listing": "Objekt",
    "checkIn": "Anreise",
    "checkOut": "Abreise",
    "guest": "Gast",
    "payoutStatus": "Ausgezahlt",
    "payoutDone": "Ja",
    "payoutPending": "Nein"
  },
  "packageOrder": {
    "title": "Paket bestellen",
    "priceBreakdown": "Preisübersicht",
    "fiskekortPart": "Angelkarte",
    "accommodationPart": "Unterkunft",
    "combinedTotal": "Gesamtpreis",
    "validFrom": "Kartenbeginn (Check-in)",
    "checkIn": "Check-in",
    "checkOut": "Check-out",
    "guestCount": "Anzahl Gäste",
    "guestName": "Ihr Name",
    "guestEmail": "E-Mail",
    "guestPhone": "Telefon (optional)",
    "notes": "Nachricht (optional)",
    "submitBtn": "Bestellen und bezahlen",
    "submitting": "Sende…",
    "paymentProcessing": "Zahlung wird verarbeitet…",
    "paymentConfirmed": "Paket bestellt!",
    "paymentConfirmedDesc": "Angelkarte und Unterkunft bestätigt. Petri Heil!",
    "paymentPending": "Zahlung ausstehend",
    "paymentPendingDesc": "Zahlung noch nicht bestätigt. Prüfen Sie Meine Bestellungen in Kürze.",
    "paymentCancelled": "Zahlung abgebrochen",
    "paymentCancelledDesc": "Sie können es erneut versuchen.",
    "viewMyBookings": "Meine Buchungen anzeigen",
    "loginRequired": "Sie müssen sich anmelden, um ein Paket zu bestellen"
  },
  "riverPage": {
    "notFound": "Fluss nicht gefunden",
    "temporarilyClosed": "Vorübergehend geschlossen",
    "requiresDisinfection": "Desinfektion erforderlich",
    "packagesSection": "Pakete — Angelschein + Unterkunft",
    "valdsSection": "Angelzonen und Angelscheine",
    "accommodationSection": "Unterkunft",
    "viewVald": "Zone ansehen",
    "noValds": "Keine Zonen registriert",
    "noProductsForVald": "Keine Angelscheine verfügbar",
    "mapSection": "Flusskarte",
    "fishingRulesTitle": "Fischereiregeln",
    "eventsSection": "Was ist in der Saison los",
    "staySection": "Wohnen, essen und erleben bei {{name}}",
    "readMore": "Mehr lesen",
    "placeCategory_hotel": "Hotel",
    "placeCategory_restaurant": "Restaurant",
    "placeCategory_camping": "Camping",
    "placeCategory_cabin": "Hütten",
    "placeCategory_shop": "Geschäft",
    "placeCategory_other": "Sonstiges",
    "filterValds": "Vald suchen…",
    "noValdMatch": "Kein Vald entspricht deiner Suche",
    "fromPrice": "ab {{price}}",
    "cardCount_one": "{{count}} Karte",
    "cardCount_other": "{{count}} Karten",
    "noCardsAvailable": "Keine Karten verfügbar",
    "showAllValds": "Alle {{count}} Vald anzeigen",
    "seePermits": "Angelkarten ansehen",
    "nearbyFilter_all": "Alle",
    "nearbyFilter_stay": "Unterkunft",
    "nearbyFilter_eat": "Essen",
    "nearbyFilter_shop": "Geschäfte",
    "nearbyFilter_other": "Sonstiges",
    "nearbyNear": "Nächste zu",
    "nearbyNearNone": "Keine Auswahl",
    "nearbyDistance": "{{km}} km Luftlinie von {{vald}}",
    "nearbyBookable": "Hier buchbar",
    "nearbyAd": "Gesponserter Inhalt",
    "nearbyTag_fiskekort": "Verkauft Angelkarten",
    "nearbyTag_tackle": "Angelbedarf",
    "nearbyTag_guide": "Guide",
    "nearbyTag_boat": "Bootsverleih",
    "nearbyTag_drying": "Trockenraum",
    "nearbyTag_freezer": "Gefrierfach",
    "nearbyTag_earlyBreakfast": "Frühes Frühstück",
    "mapLayer_valds": "Valds",
    "mapLayer_spots": "Angelplätze",
    "nearbySponsor": "Unterstützt {{river}}",
    "nearbyPick": "Empfohlen vom Flussverband",
    "nearbyShowOnMap": "Auf der Karte zeigen",
    "sponsorsRow": "Unterstützt von",
    "placeCategory_attraction": "Sehenswürdigkeit",
    "nearbyFilter_see": "Erlebnisse",
    "nearbyFilter_family": "Familie",
    "nearbyFamily": "Für die ganze Familie",
    "nearbyVisit": "Website besuchen",
    "nearbyCall": "Anrufen",
    "sponsorMain": "Hauptsponsor"
  },
  "fiskekortBevis": {
    "statusActive": "Aktiv — Schein gültig",
    "refLabel": "Ref.",
    "print": "Drucken / Teilen",
    "catchCtaText": "Etwas gefangen? Vergiss nicht deinen Fang zu registrieren!",
    "catchCtaBtn": "Fang registrieren"
  },
  "discovery": {
    "title": "Finde Angelscheine für norwegische Lachsflüsse",
    "intro": "Entdecke Reviere und kaufe Angelscheine von Revierbesitzern, die über Lakseborsen verkaufen. Filtern nach Fluss, Angeltechnik oder Verfügbarkeit.",
    "filterRiver": "Nach Fluss filtern",
    "allRivers": "Alle Flüsse",
    "flyFishing": "Fliegenfischen",
    "boatFishing": "Bootsfischen",
    "hasFiskekort": "Angelkarte",
    "clearFilters": "Filter zurücksetzen",
    "resultCount": "{{count}} Reviere",
    "noResults": "Keine Reviere entsprechen dem Filter.",
    "buyFiskekort": "Angelkarte kaufen",
    "seeVald": "Revier ansehen",
    "searchPlaceholder": "Nach Revier oder Fluss suchen",
    "sortLabel": "Sortieren",
    "sortName": "Name (A-Z)",
    "sortPrice": "Preis"
  },
  "bliValdeier": {
    "title": "Revierinhaber werden",
    "lead": "Sie wurden eingeladen, Revierinhaber für {{valdName}} auf {{riverName}} zu werden.",
    "vald": "Revier",
    "river": "Fluss",
    "loginHint": "Melden Sie sich mit dem auf die eingeladene E-Mail registrierten Konto an, um zu akzeptieren.",
    "loginAndAccept": "Anmelden und akzeptieren",
    "autoClaimHint": "Registrierung wird abgeschlossen…",
    "claiming": "Eigentümerschaft wird registriert…",
    "successTitle": "Willkommen als Revierinhaber!",
    "successDesc": "Sie sind jetzt als Inhaber von {{valdName}} registriert.",
    "goToValdAdmin": "Zum Revier-Admin",
    "notFoundTitle": "Einladung nicht gefunden",
    "notFoundDesc": "Der Link ist ungültig oder abgelaufen.",
    "expiredTitle": "Einladung abgelaufen",
    "expiredDesc": "Bitten Sie den Administrator, eine neue Einladung zu senden.",
    "claimedTitle": "Bereits verwendet",
    "claimedDesc": "Diese Einladung wurde bereits angenommen.",
    "errorTitle": "Etwas ist schiefgelaufen"
  },
  "komIGang": {
    "selectVald": "Revier auswählen",
    "chooseVald": "Ein Revier auswählen",
    "step1Title": "Kontaktinformationen",
    "step1Desc": "Kontaktdaten und eine Beschreibung des Reviers eingeben. Dies wird öffentlich angezeigt.",
    "contactName": "Kontaktperson",
    "contactNamePlaceholder": "Name oder Organisation",
    "phone": "Telefon",
    "email": "E-Mail",
    "website": "Website",
    "description": "Beschreibung",
    "descriptionPlaceholder": "Beschreiben Sie das Revier, die Angelbedingungen, Regeln usw.",
    "step2Title": "Karte und Angelmethoden",
    "step2Desc": "Das Revier auf der Karte platzieren, Grenzen zeichnen und Angeltechniken auswählen.",
    "mapLocation": "Kartenposition (klicken zum Platzieren)",
    "polygon": "Reviergrenze (optional)",
    "flyFishing": "Geeignet für Fliegenfischen",
    "boatFishing": "Angeln vom Boot möglich",
    "step3Title": "Angelstellen",
    "step3Desc": "Spezifische Angelstellen auf der Karte hinzufügen (optional).",
    "step3Hint": "Sie können Angelstellen jederzeit im Revier-Admin-Panel hinzufügen.",
    "back": "Zurück",
    "nextStep": "Nächster Schritt",
    "skipWizard": "Überspringen",
    "goToValdAdmin": "Zum Revier-Admin"
  },
  "installPrompt": {
    "text": "Lakseborsen zum Startbildschirm hinzufügen für schnelleren Zugriff",
    "iosHint": "Lakseborsen zum Home-Bildschirm hinzufügen: Öffne im Browser das Teilen-Menü und wähle „Zum Home-Bildschirm“.",
    "install": "Hinzufügen",
    "dismiss": "Schließen"
  },
  "textSize": {
    "label": "Textgröße",
    "normal": "Normale Textgröße",
    "large": "Große Textgröße",
    "xlarge": "Sehr große Textgröße"
  },
  "statsSection": {
    "title": "Statistik und Diagramme",
    "yearLabel": "Saison",
    "tooFewData": "Es werden mehr Daten benötigt, um diese Statistik anzuzeigen",
    "noCatchesForYear": "Keine registrierten Fänge in dieser Saison",
    "loading": "Statistik wird geladen…",
    "axisCatches": "Fänge",
    "axisAvgWeight": "Durchschnittsgewicht (kg)",
    "axisWeek": "Woche",
    "axisHour": "Stunde",
    "kpi": {
      "totalCatches": "Anzahl Fänge",
      "totalWeight": "Gesamtgewicht",
      "avgWeight": "Durchschnittsgewicht",
      "biggestFish": "Größter Fisch",
      "releaseRate": "Anteil freigelassen",
      "uniqueAnglers": "Aktive Angler",
      "cpue": "Fänge pro Angler",
      "fishingHours": "Angelstunden",
      "catchesPerHour": "Fang pro Stunde",
      "anglersNow": "Angler jetzt"
    },
    "fishType": {
      "title": "Verteilung nach Fischart",
      "subtitle": "Anzahl Fänge pro Art"
    },
    "gear": {
      "title": "Welches Gerät fängt am meisten?",
      "subtitle": "Fänge nach Gerätetyp"
    },
    "weekly": {
      "title": "Wann in der Saison ist das Angeln am besten?",
      "subtitle": "Fänge pro Woche"
    },
    "hour": {
      "title": "Zu welcher Tageszeit beißen die Fische?",
      "subtitle": "Fänge pro Tagesstunde"
    },
    "airTemp": {
      "title": "Lufttemperatur und Fänge",
      "subtitle": "Anzahl Fänge und Durchschnittsgewicht pro Temperatur"
    },
    "waterTemp": {
      "title": "Wassertemperatur und Fänge",
      "subtitle": "Anzahl Fänge und Durchschnittsgewicht pro Temperatur"
    },
    "waterFlow": {
      "title": "Wasserführung und Fänge",
      "subtitle": "Anzahl Fänge und Durchschnittsgewicht pro Wasserführungsstufe"
    },
    "historicalHeader": "Historische Übersicht",
    "yearly": {
      "title": "Fänge pro Saison",
      "subtitle": "Gesamtzahl registrierter Fänge, Jahr für Jahr"
    },
    "typical": {
      "title": "Typische Saison vs. dieses Jahr",
      "subtitle": "Wöchentlicher Durchschnitt basierend auf {{yearCount}} historischen Saisons",
      "avgLabel": "Durchschnitt",
      "currentLabel": "{{year}}"
    },
    "biggest": {
      "title": "Größte Fänge aller Zeiten",
      "subtitle": "Top 10 — Klicken, um den Fang anzuzeigen"
    },
    "showAllCharts": "Alle Diagramme anzeigen"
  },
  "notFound": {
    "title": "Seite nicht gefunden",
    "message": "Wir konnten die gesuchte Seite nicht finden.",
    "backHome": "Zurück zur Startseite"
  },
  "terms": {
    "title": "Angelbedingungen",
    "accept": "Ich habe die Bedingungen gelesen und akzeptiere sie",
    "mustAccept": "Du musst die Bedingungen akzeptieren, um fortzufahren.",
    "translationNote": "Dies ist eine Übersetzung. Bei Abweichungen gilt der norwegische Text.",
    "noticeTitle": "Angelbedingungen für das Gewässersystem",
    "noticeBody": "Für dieses Gewässersystem wurden Angelbedingungen festgelegt, und du hast sie noch nicht akzeptiert. Sie gelten unabhängig davon, wo du deine Angelkarte gekauft hast. Du kannst deinen Fang weiterhin registrieren.",
    "readAndAccept": "Bedingungen lesen und akzeptieren",
    "acceptNow": "Ich akzeptiere die Bedingungen",
    "acceptFailed": "Deine Zustimmung konnte nicht gespeichert werden. Bitte versuche es erneut."
  },
  "checkin": {
    "intro": "Du angelst gerade? Starte das Angeln, damit der Flussverband sehen kann, wie viel Angelzeit hinter den Fängen steckt.",
    "start": "Jetzt mit dem Angeln beginnen",
    "end": "Angeln beendet",
    "active": "Du angelst bei {{vald}}",
    "endFailed": "konnte nicht beendet werden",
    "pickVald": "Wähle zuerst unten ein Vald aus.",
    "privacy": "Wir speichern nur Zeiten, nicht deinen Standort.",
    "sessions": {
      "title": "Deine Einheiten",
      "intro": "Du hast vergessen, auf „Angeln starten“ oder „Angeln beendet“ zu tippen? Füge die Einheit hier hinzu oder korrigiere sie. Die Zeiten sind selbst angegeben, und du kannst Einheiten der letzten 60 Tage hinzufügen (höchstens 14 Stunden pro Einheit).",
      "empty": "Noch keine Einheiten.",
      "add": "Einheit hinzufügen",
      "edit": "Bearbeiten",
      "delete": "Löschen",
      "confirmDelete": "Diese Einheit löschen?",
      "vald": "Vald",
      "start": "Start",
      "end": "Ende",
      "save": "Speichern",
      "cancel": "Abbrechen",
      "running": "Läuft",
      "unknown": "Dauer unbekannt: Einheit korrigieren",
      "manual": "manuell eingetragen",
      "hm": "{{h}} Std. {{m}} Min.",
      "errors": {
        "end_before_start": "Das Ende muss nach dem Start liegen.",
        "too_long": "Eine Einheit darf höchstens 14 Stunden dauern.",
        "in_future": "Der Zeitpunkt darf nicht in der Zukunft liegen.",
        "too_old": "Du kannst nur Einheiten der letzten 60 Tage hinzufügen.",
        "overlap": "Diese Einheit überschneidet sich mit einer anderen deiner Einheiten.",
        "open_session": "Beende die Einheit stattdessen mit „Angeln beendet“.",
        "end_required": "Gib an, wann die Einheit geendet hat.",
        "vald_not_found": "Vald nicht gefunden.",
        "generic": "Die Einheit konnte nicht gespeichert werden. Bitte versuche es erneut."
      }
    }
  },
  "elvekort": {
    "notFound": "Elvekort nicht gefunden.",
    "voluntary": "Das Elvekort ist freiwillig. Du brauchst es weder zum Kauf einer Angelkarte noch zum Registrieren eines Fangs.",
    "buy": "Elvekort kaufen",
    "validPeriod": "Gültig {{from}} – {{to}}",
    "myCards": "Meine Elvekort",
    "offerTitle": "Elvekort für das Gewässersystem",
    "confirmedTitle": "Elvekort gekauft",
    "cancelledTitle": "Die Zahlung wurde abgebrochen",
    "processing": "Zahlung wird verarbeitet…",
    "pendingHint": "Die Zahlung ist noch nicht bestätigt. Sieh in Kürze unter „Meine Elvekort“ nach."
  },
  "riversPage": {
    "metaTitle": "Flüsse und Reviere – Lachsflüsse in Norwegen | Lakseborsen",
    "metaDescription": "Übersicht über Lachsflüsse und Reviere mit Angelkarten, Saison und Unterkunft.",
    "title": "Flüsse und Reviere",
    "intro": "Alle Flüsse auf Lakseborsen mit ihren Revieren. Wähle einen Fluss für Saison, Regeln, Unterkunft und Essen in der Nähe.",
    "closed": "Vorübergehend gesperrt",
    "valds": "Reviere",
    "seeRiver": "{{river}} ansehen",
    "aboutRiver": "Über den Fluss",
    "valdsCount": "{{count}} Reviere"
  }
}
